/* ===== The Pawlish Pro Collapsible Content - scoped accordion lifecycle ===== */
(function () {
  if (window.PawlishCollapsibleContent && typeof window.PawlishCollapsibleContent.init === 'function') {
    window.PawlishCollapsibleContent.init(document);
    return;
  }

  var instances = new WeakMap();

  function getRoots(scope) {
    var roots = [];
    var context = scope && scope.querySelectorAll ? scope : document;

    if (context.matches && context.matches('[data-pro-collapsible-section]')) roots.push(context);

    context.querySelectorAll('[data-pro-collapsible-section]').forEach(function (root) {
      roots.push(root);
    });

    return roots;
  }

  function initRoot(root) {
    if (instances.has(root)) return;

    var accordion = root.querySelector('[data-pro-collapsible-content]');
    if (!accordion || accordion.dataset.closeOthers !== 'true') return;

    var controller = new AbortController();

    accordion.addEventListener(
      'toggle',
      function (event) {
        var current = event.target;

        if (!current || current.tagName !== 'DETAILS' || !current.open || current.parentElement !== accordion) return;

        Array.prototype.forEach.call(accordion.children, function (item) {
          if (item !== current && item.tagName === 'DETAILS' && item.open) {
            item.removeAttribute('open');
          }
        });
      },
      { capture: true, signal: controller.signal }
    );

    root.dataset.proCollapsibleReady = 'true';

    instances.set(root, {
      destroy: function () {
        controller.abort();
        root.removeAttribute('data-pro-collapsible-ready');
      },
    });
  }

  function destroyRoot(root) {
    var instance = instances.get(root);
    if (!instance) return;

    instance.destroy();
    instances.delete(root);
  }

  function init(scope) {
    getRoots(scope).forEach(initRoot);
  }

  function destroyWithin(scope) {
    getRoots(scope).forEach(destroyRoot);
  }

  window.PawlishCollapsibleContent = {
    init: init,
    destroyWithin: destroyWithin,
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
  });
})();
